module.exports = __webpack_public_path__ + "media/images/channels/cardiology-999161e19a5b2aba88b2e435cc757e1c.jpg";